import React, { ReactNode, Suspense } from "react";
import { Navigate } from "react-router-dom";

import LoadingSpinner from "../Icons/LoadingSpinner";
import { paths } from "./paths";
import { ROLE } from "../utils/constant";


// Training

const TrainingListPage = React.lazy(() => import('../pages/trainings/trainers/list'));


const PaymentsListPage = React.lazy(() => import('../pages/trainings/payments/page'));

const CounsellorsListPage = React.lazy(() => import('../pages/trainings/counselors/page'));

const ProgramListPage = React.lazy(() => import('../pages/trainings/program/list'));

const ClassesListPage = React.lazy(() => import('../pages/trainings/classes/page'));

const TrainingDahboardPage = React.lazy(() => import('../pages/trainings/dashboard/page'));

const FeeManagementListPage = React.lazy(() => import('../pages/trainings/fee-management/list'));


const ProtectedAdminHRRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
    const role = localStorage.getItem('roleName') || '';
    return (ROLE.ALLOWED_ADMIN_HR_TEACHER.includes(role.toUpperCase())) ? (
        <> {children} </>
    ) : (
        <Navigate to="/dashboard" />
    );
};




const renderProtectedHRRoute = (Component: React.ComponentType<any>, props?: any) => (
    <Suspense fallback={<LoadingSpinner className="mr-2 h-full w-14 animate-spin" />}>
        <ProtectedAdminHRRoute>
            <Component {...props} />
        </ProtectedAdminHRRoute>
    </Suspense>
);

const { trainings } = paths

export const TrainingRoutes = [{
    path: trainings.root,
    element: renderProtectedHRRoute(TrainingDahboardPage),
    title: "Training List",
    role: ROLE.ALLOWED_SALES_DEPT,
},
{
    path: trainings.trainers,
    element: renderProtectedHRRoute(TrainingListPage),
    title: "Training List",
    role: ['admin', 'Teacher', 'HR'],
},
{
    path: trainings.program,
    element: renderProtectedHRRoute(ProgramListPage),
    title: "Training List",
    role: ['admin', 'Teacher', 'HR'],
},
{
    path: trainings.payments,
    element: renderProtectedHRRoute(PaymentsListPage),
    title: "Payments",
    role: ['admin', 'Teacher', 'HR'],
},
{
    path: trainings.counselors,
    element: renderProtectedHRRoute(CounsellorsListPage),
    title: "Training List",
    role: ['admin', 'Teacher', 'HR'],
},
{
    path: trainings.classes,
    element: renderProtectedHRRoute(ClassesListPage),
    title: "Training List",
    role: ['admin', 'Teacher', 'HR'],
},
{
    path: trainings.fee,
    element: renderProtectedHRRoute(FeeManagementListPage),
    title: "Training List",
    role: ['admin', 'Teacher', 'HR'],
},
];